export default "__VITE_ASSET__Dt18NAME__"